import { Routes, Route, Navigate } from "react-router-dom";
import routes from "routes";

export default function Auth() {
  const getRoutes = (routes: RoutesType[]): any => {
    return routes.map((prop, key) => {
      if (prop.layout === "/auth") {
        return (
          <Route path={`/${prop.path}`} element={prop.component} key={key} />
        );
      } else {
        return null;
      }
    });
  };

  return (
    <div className="flex min-h-screen w-full items-center justify-center bg-surfacePrimary p-4">
      <div className="flex w-full max-w-[480px] flex-col items-center justify-center">
        <Routes>
          {getRoutes(routes)}
          <Route
            path="/"
            element={<Navigate to="/auth/sign-in" replace />}
          />
        </Routes>
      </div>
    </div>
  );
}
